import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import queryString from "query-string";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";

var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
class CreateUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerList: [],
      timeZone: [],
      roles: [],
      customerID: "default",
      customerName: "",
      time: "default",
      timeZoneId: "",
      name: "",
      description: "",
      role: "User",
      email: "",
      password: "",
      confpassword: "",
      realTimeValidation: true,
      customerID_error: false,
      time_error: false,
      name_error: false,
      role_error: false,
      email_error: false,
      emailformat_error: false,
      password_error: false,
      passwordlength_error: false,
      confpassword_error: false,
      showSystemAdminWarning: false,
      pendingRole: "",
      isPrivate: false,
    };
    this.formSubmit = false;
  }
  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    if (values.selectedAsset) {
      this.setState({
        customerName: values.selectedAsset,
        customerID: values.customerId,
      });
    }
    //Get all customer id
    this.props.setLoadingPageAction(true);

    try {
      const customerList = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ customerList: customerList.data });
      console.log("customer id", customerList.data);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    //Get all Time zone
    this.props.setLoadingPageAction(true);

    try {
      const timeZone = await axios.get(
        `${apiHost}/api/Customer/GetAllTimeZone`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ timeZone: timeZone.data });
      console.log("timeZone ", timeZone.data);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
    //Get all Roles
    this.props.setLoadingPageAction(true);

    try {
      const roles = await axios.get(`${apiHost}/api/auth/AllRoles`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      roles.data.sort((a,b) => {
        if(a.roleName.toLowerCase() > b.roleName.toLowerCase()){
          return -1;
        }
        else if(a.roleName.toLowerCase() < b.roleName.toLowerCase()){
          return 1;
        }
       else{
          return 0;
        }
      })
      this.setState({ roles: roles.data });
      console.log("timeZone ", roles.data);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }
  handleCustomeridChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({ customerID_error: true });
    } else {
      this.setState({ customerID_error: false });
    }
    this.setState({ customerID: e.target.value });
  }
  handleTimeChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({ time_error: true });
    } else {
      this.setState({ time_error: false });
    }
    this.state.timeZone.forEach((time) => {
      if (time.timeZoneCity == e.target.value) {
        this.setState({ timeZoneId: time.timeZonesId });
      }
    });
    this.setState({ time: e.target.value });
  }
  handleNameChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
    }
    this.setState({ name: e.target.value });
  }
  handleRoleChange(e) {
    console.log("e.target.value", e.target.value);
    const selectedRole = e.target.value;
    if (selectedRole == "default") {
      this.setState({ role_error: true });
    } else {
      this.setState({ role_error: false });
    }

    if (selectedRole === "SystemAdmin" && this.state.role !== "SystemAdmin") {
      this.setState({
        showSystemAdminWarning: true,
        pendingRole: selectedRole,
      });
      return;
    }

    this.setState({ role: selectedRole });
  }
  confirmSystemAdminRole = () => {
    this.setState({
      role: this.state.pendingRole || "SystemAdmin",
      pendingRole: "",
      showSystemAdminWarning: false,
      role_error: false,
    });
  }
  cancelSystemAdminRole = () => {
    this.setState({
      pendingRole: "",
      showSystemAdminWarning: false,
    });
  }
  handleEmailChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      // this.setState({emailformat_error:false})
      this.setState({ email_error: true });
    } else if (!e.target.value.match(mailformat)) {
      // this.setState({emailformat_error:true})
      this.setState({ email_error: false });
    } else {
      // this.setState({emailformat_error:false})
    }
    this.setState({ email: e.target.value });
  }
  handleDescription = (e) => {
    console.log("e.target.value", e.target.value);
    this.setState({ description: e.target.value });
  };
  handlePrivateChange = (e) => {
    this.setState({ isPrivate: e.target.checked });
  };
  handlePasswordChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      this.setState({ passwordlength_error: false });

      this.setState({ password_error: true });
    } else if (e.target.value.length < 6 || e.target.value.length > 30) {
      this.setState({ password_error: false });
      this.setState({ passwordlength_error: true });
    } else {
      this.setState({ passwordlength_error: false });
    }
    this.setState({ password: e.target.value });
  }
  handleConfirmPasswordChange(e) {
    if (e.target.value !== this.state.password) {
      this.setState({ confpassword_error: true });
    } else {
      this.setState({
        confpassword_error: false,
        confpassword: e.target.value,
      });
    }
  }
  async handleSubmit() {
    console.log("clicked");
    this.formSubmit = true;

    if (this.state.customerID == "default") {
      this.setState({ customerID_error: true });
      this.formSubmit = false;
    }
    if (this.state.time == "default") {
      this.setState({ time_error: true });
      this.formSubmit = false;
    }
    if (this.state.name == "") {
      this.setState({ name_error: true });
      this.formSubmit = false;
    }
    if (this.state.role == "default") {
      this.setState({ role_error: true });
      this.formSubmit = false;
    }
    if (this.state.email == "") {
      this.setState({ email_error: true });
      this.formSubmit = false;
    } else if (!this.state.realTimeValidation) {
      this.formSubmit = false;
    }
    if (this.state.password == "") {
      this.setState({ password_error: true });
      this.formSubmit = false;
    } else if (this.state.confpassword == "") {
      this.setState({ confpassword_error: true });
      this.formSubmit = false;
    }

    if (this.formSubmit) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/auth/register`,
          {
            Username: this.state.name,
            Description: this.state.description,
            Password: this.state.password,
            CustomerId: this.state.customerID,
            TimeZoneId: this.state.timeZoneId,
            Email: this.state.email,
            UserType: [this.state.role],
            DisplayName: this.state.name,
            IsPrivate: localStorage.getItem("role") === "SystemAdmin" && this.state.isPrivate
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        // this.props.history.push("/users");

        this.props.history.goBack();
        console.log("customer id", response.data);
        this.props.setLoadingPageAction(false);
      }
      catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else if (e.response.status == "400") {
          for(var key in e.response.data.errors) {
            // console.log("userrespo",e.response.data.errors[key])
            alert(e.response.data.errors[key])

          }
          // this.props.history.push("/login");
        }else {
          if (e.response.data.statusCode == "1") {
            this.props.setErrorMessageAction("User Already Exist");
          } else {
            this.props.setErrorMessageAction(`${e}`);
          }
          // this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  }

  realTimeUserValidation = async (e) => {
    try {
      let response = await axios.get(
        `${apiHost}/api/Auth/IsEmailExist?Email=${encodeURIComponent(e.target.value)}&userId=${encodeURIComponent("")}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      console.log("response", response.data);
      this.setState({ realTimeValidation: true });
    } catch (e) {
      this.setState({ realTimeValidation: false });

      console.log(
        `Axios request failed.Error logged on Realtime User Check${e}`
      );
    }
  };

  render() {
    const values = queryString.parse(this.props.location.search);
    const isSystemAdmin = localStorage.getItem("role") === "SystemAdmin";
    console.log("roles", this.state.roles);
    var selectCustomerTag;
    if (values.selectedAsset) {
      selectCustomerTag = (
        <Form.Control
          as="select"
          onChange={this.handleCustomeridChange.bind(this)}
          value={this.state.customerID}
        >
          <option value="default">Select Customer</option>
          {this.state.customerList.map((customer, index) => {
            return <option value={customer.id}>{customer.name}</option>;
          })}
        </Form.Control>
      );
    } else {
      selectCustomerTag = (
        <Form.Control
          as="select"
          onChange={this.handleCustomeridChange.bind(this)}
        >
          <option value="default">Select Customer</option>
          {this.state.customerList.map((customer, index) => {
            return <option value={customer.id}>{customer.name}</option>;
          })}
        </Form.Control>
      );
    }
    return (
      <div>
        <Layout>
          <Helmet>
            <title>Create user </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper user-create-page">
              <div className="user-create-header">
                <div>
                  <span className="user-create-kicker">User creator</span>
                  <h2>Create User</h2>
                  <div className="user-create-subtitle">
                    <span>{this.state.customerName || "Select customer"}</span>
                    <span>{this.state.role || "Select role"}</span>
                    <span>{this.state.time === "default" ? "Select time zone" : this.state.time}</span>
                  </div>
                </div>
                <div className="user-create-actions">
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  <Button
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                    disabled={!this.state.realTimeValidation}
                  >
                    Create User
                  </Button>
                </div>
              </div>

              <Form className="user-create-form-modern">
                <section className="user-create-section">
                  <div className="user-create-section-title">
                    <h3>Account Scope</h3>
                    <p>Customer, timezone and role assignment for this user.</p>
                  </div>
                  <div className="user-create-grid">
                    <Form.Group controlId="createUserCustomer">
                      <Form.Label>Customer</Form.Label>
                    {selectCustomerTag}
                      <p style={this.state.customerID_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Customer field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="createUserTimeZone">
                      <Form.Label>Time Zone</Form.Label>
                      <Form.Control as="select" onChange={this.handleTimeChange.bind(this)}>
                        <option value="default">Select Time Zone</option>
                        {this.state.timeZone.map((time, index) => {
                          return (
                            <option key={index} value={time.timeZoneCity}>
                              {time.timeZoneCity}
                            </option>
                          );
                        })}
                      </Form.Control>
                      <p style={this.state.time_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Time Zone field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="createUserRole">
                      <Form.Label>Role</Form.Label>
                      <Form.Control
                        as="select"
                        onChange={this.handleRoleChange.bind(this)}
                        value={this.state.role}
                      >
                        {this.state.roles.map((role, index) => {
                          return (
                            <option key={index} value={role.roleName}>{role.roleName}</option>
                          );
                        })}
                      </Form.Control>
                      <p style={this.state.role_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Role field is required.
                      </p>
                    </Form.Group>
                  </div>
                </section>

                <section className="user-create-section">
                  <div className="user-create-section-title">
                    <h3>User Details</h3>
                    <p>Identity, email and profile notes for the new user.</p>
                  </div>
                  <div className="user-create-grid">
                    <Form.Group controlId="createUserName">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.name}
                        onChange={this.handleNameChange.bind(this)}
                      />
                      <p style={this.state.name_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Name field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="createUserEmail">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        onChange={(e) => {
                          this.handleEmailChange(e);
                          this.realTimeUserValidation(e);
                        }}
                      />
                      <p style={this.state.email_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Email field is required.
                      </p>
                      {this.state.email != "" && (
                        <p style={!this.state.realTimeValidation ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                          Email already in use
                        </p>
                      )}
                      <p style={this.state.emailformat_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Email field is not a valid e-mail address.
                      </p>
                    </Form.Group>

                    <Form.Group className="user-create-wide" controlId="createUserDescription">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows="3"
                        onChange={this.handleDescription}
                      />
                    </Form.Group>

                    {isSystemAdmin && (
                      <Form.Group className="user-create-wide user-private-toggle" controlId="createUserPrivate">
                        <Form.Check
                          checked={this.state.isPrivate}
                          label="Private simulation account"
                          onChange={this.handlePrivateChange}
                          type="checkbox"
                        />
                        <p>Hidden from Community Managers. Visible to System Admin and VtDemo accounts.</p>
                      </Form.Group>
                    )}
                  </div>
                </section>

                <section className="user-create-section">
                  <div className="user-create-section-title">
                    <h3>Security</h3>
                    <p>Set the initial password for this account.</p>
                  </div>
                  <div className="user-create-grid">
                    <Form.Group controlId="createUserPassword">
                      <Form.Label>Password</Form.Label>
                      <Form.Control type="text" onChange={this.handlePasswordChange.bind(this)} />
                      <p style={this.state.password_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Password field is required.
                      </p>
                      <p style={this.state.passwordlength_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Password restricted 6-30 characters long
                      </p>
                    </Form.Group>

                    <Form.Group controlId="createUserConfirmPassword">
                      <Form.Label>Confirm Password</Form.Label>
                      <Form.Control type="text" onChange={this.handleConfirmPasswordChange.bind(this)} />
                      <p style={this.state.confpassword_error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The password and confirmation password do not match.
                      </p>
                    </Form.Group>
                  </div>
                </section>

                <div className="user-create-footer">
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  <Button
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                    disabled={!this.state.realTimeValidation}
                  >
                    Create User
                  </Button>
                </div>
              </Form>
            </div>
          </div>
          <Modal
            className="user-admin-warning-modal"
            centered
            show={this.state.showSystemAdminWarning}
            onHide={this.cancelSystemAdminRole}
          >
            <Modal.Header closeButton>
              <Modal.Title>System Administrator Privileges</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                Are you sure you want to give this user System Administrator privileges?
              </p>
              <p>
                This will grant system wide access and should be reserved only for Visiontrak Admin/Staff.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={this.cancelSystemAdminRole}>
                Cancel
              </Button>
              <Button variant="primary" onClick={this.confirmSystemAdminRole}>
                Confirm Privileges
              </Button>
            </Modal.Footer>
          </Modal>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateUser);
